module.exports = __webpack_public_path__ + "img/referral_used.7069544e.svg";